import { injectable } from 'inversify'

import { IDataModelTypeStrategy } from '../../../types/IDataModelTypeStrategy'

@injectable()
export class OrganizationUserImportDataModelTypeStrategy implements IDataModelTypeStrategy {
  public readonly baseUrl: string

  constructor() {
    this.baseUrl = `/organization_user_imports`
  }

  canEditColumns: boolean
}
